import script from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormGeneralComponent.vue?vue&type=style&index=0&id=aed35c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aed35c14"]])

export default __exports__